<template>
  <div>
      <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <!-- <PageLoader v-bind:storage="appLoading" /> -->
    <v-layout pt-4 wrap justify-left>
      <v-flex xs12 xl11 px-2>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs5 sm3 md3 lg2 xl2>
            <v-layout wrap justify-center >
              <v-flex xs3 sm2 text-left align-self-center>
               <v-img
                  src="./../../../assets/Images/agogo.png"
                  contain
                  height="30px"
                ></v-img>
              </v-flex>
              <v-flex xs9 sm8 text-left pl-2 align-self-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
                >
                  Offers
                </span>
              </v-flex>
                                  
            </v-layout>
          </v-flex>
         

        </v-layout>
        <v-layout wrap py-2 justify-end pr-12>
          <v-flex xs2 md2> <v-btn block color="green" dense outlined to="Offers/Add">Add offer</v-btn> </v-flex>
        </v-layout>
        <v-layout wrap justify-start v-if="offerList.length > 0">
          <template v-for="(item, i) in offerList">
            <v-flex xs12 xl11 :key="item._id" pr-lg-6 pr-xl-0>
              <OfferItem v-bind:storage="item" @stepper="winStepper" />
            </v-flex>
            <v-flex xs12 xl11 :key="i" py-4>
              <v-divider></v-divider>
            </v-flex>
          </template>
        </v-layout>
        <v-layout wrap justify-center pb-4 v-if="pages > 1" >
          <v-flex xs12>
            <v-pagination
              v-model="currentPage"
              :length="pages"
              :total-visible="7"
              color="#FF0000"
            ></v-pagination>
          </v-flex>
        </v-layout>
        <v-layout wrap pt-5 justify-center v-if="offerList.length < 1">
          <v-flex xs12>
            <span
              style="
                font-family: poppinsregular;
                font-size: 20px;
                color: #000000;
              "
            >
              Oops! No Offers Found
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import axios from "axios";
import OfferItem from "./offerItem";
import axios from 'axios';
export default {
  components: {
    OfferItem,
  },
  data() {
    return {
     
      currentPage: 1,
      pages: 1,
      count: 10,
      offerList:[],
      appLoading:false,
      ServerError:false,
      
    };
  },
  watch: {
    listStatus() {
      this.getData();
    },
    currentPage() {
      this.getOffer();
    },
  },
  beforeMount() {
    this.getOffer()
  },
  methods: {
    winStepper(window_data) {
      if (window_data.getData) {
        this.getOffer();
      }
    },
    getOffer()
    {
      this.appLoading = true
      axios({
          method: "post",
          url: "seller/my/offer/list",
         
          headers: {
            token: localStorage.getItem("token"),
          },
          data:{
            limit:10,
            page:this.currentPage
          }
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status == true) {
             this.offerList = response.data.data;
             this.pages = Math.ceil( (response.data.totalLength / 10))

            } 
            else {
              this.showSnackBar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
    }
  
  },

};
</script>